import { Menu } from "primereact/menu";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppButton from "../../common/AppButton";
import { IoChevronDown } from "react-icons/io5";

export default function InvoiceToggles() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showwMenu, setShowMenu] = useState(false);

  const handleTabChange = (event) => {
    const value = event.item.label;
    if (value) {
      navigate(
        `/invoices/${value === "Paid" ? "invoicePaid" : "invoiceUnpaid"}`,
        { state: { data: location.state?.data } }
      );
    }
  };
  const items = [
    {
      label: "Paid",
      style: {
        color: "red",
      },
      icon: "pi pi-check",

      command: handleTabChange,
    },
    {
      label: "Unpaid",
      icon: "pi pi-times",
      command: handleTabChange,
    },
  ];

  const ref = React.createRef();

  return (
    <div>
      <AppButton
        onClick={(event) => {
          setShowMenu(!showwMenu);
          ref.current.toggle(event);
        }}
        className="text-primary"
        leftIcon={<IoChevronDown size={22} />}
      />

      <Menu
        model={items}
        ref={ref}
        style={{
          position: "absolute",
          top: 50,
          right: 10,
          display: showwMenu ? "block" : "none",
        }}
      />
    </div>
  );
}
